import { observer } from 'mobx-react-lite'
import { Select } from 'blaze-ui/Select/Select'
import { Item } from '@react-stately/collections'
import { TextInputField } from 'components/Form/TextInputField'
import { ShopifyBlog } from 'api/clients/BlogMetadataRecordsClient'
import Styles from '../../../BlogMetadata.module.scss'

type ShopifyBlogSelectProps = {
  blogs: ShopifyBlog[]
  selectedBlogId: string | undefined
  onBlogSelect: (blogId: string) => void
  placeholder?: string
  disabled?: boolean
}

export const ShopifyBlogSelect = observer(
  ({
    blogs,
    selectedBlogId,
    onBlogSelect,
    placeholder = 'Select a blog',
    disabled = false,
  }: ShopifyBlogSelectProps) => {
    const isEmpty = blogs.length === 0
    const isSingleBlog = blogs.length === 1

    // Auto-select single blog
    if (isSingleBlog) {
      const singleBlog = blogs[0]
      if (selectedBlogId !== singleBlog.id) {
        onBlogSelect(singleBlog.id)
      }

      return (
        <TextInputField
          wrapperClassName={Styles.inputField}
          label="Blog"
          value={singleBlog.name}
          onChange={() => {}}
          size="lg"
          labelClassName={Styles.textFieldLabel}
          isReadOnly
          isDisabled={disabled}
        />
      )
    }

    return (
      <Select
        placeholder={isEmpty ? 'No blogs available' : placeholder}
        selectedKey={selectedBlogId}
        onSelectionChange={(key) => onBlogSelect(key as string)}
        isDisabled={isEmpty || disabled}
        useButtonWidth={true}
        useFullWidth={true}
        variant="secondary"
        size="lg"
      >
        {blogs.map((blog) => (
          <Item key={blog.id} textValue={blog.name}>
            {blog.name}
          </Item>
        ))}
      </Select>
    )
  },
)
